






















import { defineComponent } from '@vue/composition-api';
import ElSwitch            from 'element-ui/lib/switch';

export default defineComponent({
  name: 'cSwitch',
  components: {
    ElSwitch,
  },
  setup() {
    const SWITCH_PRIMARY: string = getComputedStyle(document.body)
      .getPropertyValue('--switch-color');
    return {
      SWITCH_PRIMARY,
    };
  },
});
